import { z } from 'zod';
import { isMongoId } from '../../helpers';
import { CalendarDay } from '../../../utils';

export const getTrancheDataByIdsInput = z.object({
  trancheIds: z
    .array(z.string().refine(isMongoId()))
    .min(1, 'At least one tranche ID is required'),
  allocationDate: z.instanceof(CalendarDay),
});

export const runAutoAllocationInput = z.object({
  selectedCompanyId: z.string().refine(isMongoId()),
  allocationDate: z.instanceof(CalendarDay),
  dealSharePrice: z.number().positive('Deal share price must be positive.'),
  autoAllocatingTranches: z
    .array(
      z.object({
        _id: z.string().refine(isMongoId()),
        minimumInvestorPortfolioSize: z.number(),
        maximumSingleCompanyAllocation: z.number(),
        derivedTargetShares: z.number().positive({
          message:
            'Target shares must be a positive number for all selected tranches.',
        }),
        flexSharePrice: z.number().optional(),
        defaultTransactionFeePercent: z.number(),
        defaultTransactionFeeVatPercent: z.number(),
        finalDeal: z.boolean(),
      }),
    )
    .min(1, 'At least one tranche must be selected.'),
});

const investmentSchema = z.object({
  investmentId: z.string().refine(isMongoId()),
  allocatedShares: z.number(),
  investorName: z.string(),
  transactionFee: z.number(),
  transactionFeeNet: z.number(),
  transactionFeeVat: z.number(),
  subscriptionAmount: z.number(),
  defaultTransactionFeeVatPercent: z.number(),
});

const fundAllocation = z.object({
  trancheId: z.string().refine(isMongoId()),
  companyId: z.string().refine(isMongoId()),
  allocationDate: z.instanceof(CalendarDay),
  dealSharePrice: z.number().min(0, 'Deal share price must be positive.'),
  fundName: z.string(),
  finalDeal: z.boolean(),
  minimumInvestorPortfolioSize: z.number(),
  maximumSingleCompanyAllocation: z.number(),
  targetShares: z.number(),
  sharesAllocated: z.number(),
  isAutoAllocation: z.boolean(),
  transactionFeePercent: z.number(),
  defaultTransactionFeeVatPercent: z.number(),
  investments: z.array(investmentSchema),
});

export const createShareAllocationInput = z.object({
  fundAllocations: z.array(fundAllocation),
});

export const deleteDraftAllocationInput = z.object({
  draftAllocationId: z.string().refine(isMongoId(), {
    message: 'Invalid draft allocation ID.',
  }),
});

export const getDraftAllocationInput = z.object({
  draftAllocationId: z.string().refine(isMongoId(), {
    message: 'Invalid draft allocation ID.',
  }),
});

export const getAllocationInput = z.object({
  shareAllocationUploadId: z.string().refine(isMongoId(), {
    message: 'Invalid allocation ID',
  }),
});

export const editShareAllocationInput = z.object({
  shareAllocationUploadId: z.string().refine(isMongoId(), {
    message: 'Invalid share allocation upload ID.',
  }),
  fundAllocations: z.array(fundAllocation),
  updatedFundIds: z.array(z.string().refine(isMongoId())),
});

export const processShareAllocationsFromFileInput = z.object({
  fileContent: z.string().min(1),
  fileMimetype: z.string().min(1),
});
